import Settings from "./Settings";

import ProcessingResult from "../framework/ProcessingResult";

import SsoResolutionDto from "../classes/dtos/accountmodule/SsoResolutionDto";

const SsoApi = {

    // Called before sign-in: there is no token yet, so no Authorization header.
    ResolveByLoginSlugAsync: async function (loginSlug: string): Promise<ProcessingResult<SsoResolutionDto>> {
        const response = await fetch(Settings.api_url + "/Sso/ResolveByLoginSlug", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ 'loginSlug': loginSlug })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new SsoResolutionDto(data.isSso, data.domainHint));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default SsoApi;
